<template>
  <footer class="footer">
      <div class="about-links">
        <a class="about-link" href="http://bbs.duba.net/forum-6577-1.html" target="_blank">猎豹论坛</a>
        <a class="about-link" href="https://www.liebao.cn/private.html" target="_blank">隐私策略</a>
        <a class="about-link" href="http://www.ijinshan.com/intro/intro1.shtml" target="_blank">
          关于我们</a>
        <a class="about-link" href="http://www.ijinshan.com/intro/intro4.shtml" target="_blank">
          工作机会</a>
        <a class="about-link"
           href="https://www.ijinshan.com/privacy/brvip_ContinuousmonthlyLicensese.html"
           target="_blank">会员协议</a>
        <a class="about-link" href="http://www.ijinshan.com/intro/intro8.shtml" target="_blank">
          联系我们</a>
      </div>
      <p>京ICP备 12038800号-2</p>
      <p>京ICP证 120823号 京公网安备 11010502036334号 京网文（2020）0254-023号</p>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style lang="less" scoped>
.footer{
  background: #242425;
  text-align: center;
  padding: 16px 0;
}
.footer p {
  font-size: 12px;
  line-height: 16px;
  color: #525252;
  margin: 6px 0
}

.footer .about-links {
  margin-bottom: 23px
}

.footer .about-link {
  display: inline-block;
  color: #979797;
  text-decoration: none;
  padding: 0 12px;
  font-size: 12px;
  line-height: 16px
}

.footer .about-link:hover {
  color: #fff
}

.footer .about-link:not(:first-child) {
  border-left: 1px solid #979797
}
</style>
